import React from 'react'

import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'
import Text from 'components_new/atoms/Text'
import Tooltip from 'components_new/atoms/Tooltip'

import {
  EXTRA_LONG_FORECASTS,
  TCoreWidgetSettingsLoaded
} from 'types/GlobalWidget'
import { useTranslation } from 'language/translator'

interface ExtraLongForecastMissingSupportedKpiProps {
  scaleFactor: number
  widget: TCoreWidgetSettingsLoaded
}

const ExtraLongForecastMissingSupportedKpi = (
  props: ExtraLongForecastMissingSupportedKpiProps
) => {
  const { widget, scaleFactor } = props
  const { t, translateEnum } = useTranslation()

  if (widget.status.extra_long_forecast_missing_supported_kpi) {
    return (
      <Tooltip
        title={
          <>
            <Text gutterBottom={true} variant="inherit">
              {t('date_filters', 'long_forecast_not_applicable')}
            </Text>
            <Text gutterBottom={true} variant="inherit">
              {t('date_filters', 'long_forecast_includes')}
              {EXTRA_LONG_FORECASTS.map((forecast) => (
                <ul key={forecast}>
                  {translateEnum('forecast_periods', forecast).title}
                </ul>
              ))}
            </Text>
            <Text gutterBottom={true} variant="inherit">
              {t('date_filters', 'long_forecast_use_other')}
            </Text>
          </>
        }
      >
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            position: 'relative',
            zIndex: 1,
            fontSize: 14 * scaleFactor
          }}
        >
          <Icon color="warning" fontSize="inherit" name={'Warning'} />
          <Text
            color="warning.text"
            fontSize="inherit"
            fontWeight="medium"
            sx={{
              ml: '0.25em',
              cursor: 'default'
            }}
            noWrap={true}
          >
            {t('date_filters', 'long_forecast_missing')}
          </Text>
        </Box>
      </Tooltip>
    )
  }

  return null
}

export default ExtraLongForecastMissingSupportedKpi
